__turbopack_context__.v({
  "avatar": "index-module__NLJi5q__avatar",
  "bodyChat": "index-module__NLJi5q__bodyChat",
  "botAnim": "index-module__NLJi5q__botAnim",
  "chatContainer": "index-module__NLJi5q__chatContainer",
  "close": "index-module__NLJi5q__close",
  "cross": "index-module__NLJi5q__cross",
  "formChat": "index-module__NLJi5q__formChat",
  "formContain": "index-module__NLJi5q__formContain",
  "formGroup": "index-module__NLJi5q__formGroup",
  "formLine": "index-module__NLJi5q__formLine",
  "headerChat": "index-module__NLJi5q__headerChat",
  "infoMessage": "index-module__NLJi5q__infoMessage",
  "inputText": "index-module__NLJi5q__inputText",
  "messageContainer": "index-module__NLJi5q__messageContainer",
  "messageList": "index-module__NLJi5q__messageList",
  "msgBu": "index-module__NLJi5q__msgBu",
  "myMessage": "index-module__NLJi5q__myMessage",
  "openButton": "index-module__NLJi5q__openButton",
  "openContainer": "index-module__NLJi5q__openContainer",
  "submit": "index-module__NLJi5q__submit",
});
